export const formatIrr = (value, fractionDigits = 2) => {
  if (value === null || value === undefined) return 'Not meaningful';
  return `${Number(value).toFixed(fractionDigits)}%`;
};
